import React, { useState, useEffect } from 'react';
import Modal from './ModalConversion';

export const ObservationsModal = ({ isOpen, onClose, project }) => {
    const [selectedRev, setSelectedRev] = useState('general');

    // Reset selection when modal opens with a new project
    useEffect(() => {
        if (isOpen && project) {
            if (project.initialMode === 'revisions') {
                const coverInfo = project.cover_info || {};
                const revisions = Object.keys(coverInfo)
                    .filter(key => key.startsWith('observations_'))
                    .map(key => key.replace('observations_', ''))
                    .sort((a, b) => Number(a) - Number(b));
                
                if (revisions.length > 0) {
                    setSelectedRev(revisions[0]);
                } else {
                    setSelectedRev('general');
                }
            } else {
                setSelectedRev('general');
            }
        }
    }, [isOpen, project]);

    if (!project) return null;

    // Identify available revisions in cover_info
    const coverInfo = project.cover_info || {};
    const revisions = Object.keys(coverInfo)
        .filter(key => key.startsWith('observations_'))
        .map(key => key.replace('observations_', ''))
        .sort((a, b) => Number(a) - Number(b));

    const getDisplayContent = () => {
        if (selectedRev === 'general') {
            return project.observations || "No hay observaciones generales registradas para este proyecto.";
        }
        return coverInfo[`observations_${selectedRev}`] || "Sin contenido para esta revisión.";
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-3">
                <h3 className="mb-3 text-white">Observaciones</h3>
                
                {revisions.length > 0 && (
                    <div className="d-flex align-items-center gap-2 mb-4">
                        <label className="text-white-50 small mb-0">Ver historial:</label>
                        <select 
                            className="form-select form-select-sm bg-dark text-white border-secondary"
                            value={selectedRev}
                            onChange={(e) => setSelectedRev(e.target.value)}
                            style={{ width: 'auto', minWidth: '150px' }}
                        >
                            {project.initialMode !== 'revisions' && <option value="general">Observaciones Generales</option>}
                            {revisions.map(rev => (
                                <option key={rev} value={rev}>Revisión {rev}</option>
                            ))}
                        </select>
                    </div>
                )}

                <div className="mb-3 p-2 bg-dark rounded border border-secondary text-white">
                    <p className="m-0"><strong>Proyecto:</strong> {project.account}-C-{project.ink_id}</p>
                    <p className="text-white-50 small m-0">{project.title}</p>
                </div>
                
                <div className="p-4 bg-dark text-light border rounded shadow-inner" style={{ minHeight: '150px', whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
                    {getDisplayContent()}
                </div>

                <div className="d-flex justify-content-end mt-4">
                    <button type="button" className="btn btn-primary px-4" onClick={onClose}>Cerrar</button>
                </div>
            </div>
        </Modal>
    );
};

export default ObservationsModal;
